<template>
  <component :is="tag" v-bind="$attrs" v-on="$listeners" class="kvass-doughnut">
    <div v-if="hasContent" class="kvass-doughnut__content">
      <slot name="content" />
      <div v-if="hasCenter" class="kvass-doughnut__center">
        <slot name="center" />
      </div>
    </div>
    <div
      v-if="hasDimensions"
      :class="[
        'kvass-doughnut__labels',
        direction === 'row' ? 'kvass-doughnut__labels__row' : 'kvass-doughnut__labels__column',
      ]"
    >
      <slot name="dimensions" />
    </div>
  </component>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      default: () => {},
    },
    tag: {
      type: String,
      default: 'div',
    },
    direction: {
      type: String,
      default: 'column',
    },
  },
  computed: {
    hasContent() {
      return this.$slots.content
    },
    hasDimensions() {
      return this.$slots.dimensions
    },
    hasCenter() {
      return this.$slots.center
    },
  },
}
</script>

<style lang="scss">
.kvass-doughnut {
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: v-bind(direction);
  width: 100%;

  &__bg-label {
    width: 16px;
    height: 16px;
    position: relative;
    display: inline-block;
    border-radius: 100%;
  }

  &__content {
    display: flex;
    height: auto;
    position: relative;
    justify-content: center;
    align-items: center;

    > div:not(.kvass-doughnut__center) {
      position: relative;
      width: 100%;
    }
  }

  &__center {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    position: absolute;
    inset: 0;
    font-weight: 900;

    h4,
    span {
      width: 100%;
      text-align: center;
    }

    h4 {
      display: flex;
      flex-direction: column;
      font-weight: 900;
      font-size: 1.2rem;
      margin: 0;
      padding: 0;
      span {
        text-transform: capitalize;
      }
    }

    span {
      font-weight: 400;
      font-size: 1.2rem;
    }
  }

  &__labels {
    align-self: center;

    h3 {
      font-size: 1rem;
    }

    ul {
      list-style: none;
      padding-left: 0;
      display: flex;
      gap: 0.7rem;
    }

    li {
      display: flex;
      gap: 0.3rem;
      align-items: center;
    }

    &__row {
      margin-left: 1rem;
      ul {
        flex-direction: column;
      }
    }

    &__column {
      margin-top: 1rem;
      align-self: flex-start;
      ul {
        align-items: center;
        flex-wrap: wrap;
        max-width: 400px;
      }
    }
  }

  &__chart {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 1rem;
    height: 100%;
    position: relative;
  }
}
</style>
